import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";

export default function Layout({ children }) {
  const location = useLocation();
  const [showBackTop, setShowBackTop] = useState(false);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [location.pathname]);

  const noLayoutPaths = ["/login", "/register", "/admin"];
  const shouldShowLayout = !noLayoutPaths.includes(location.pathname);

  useEffect(() => {
    const handleScroll = () => {
      setShowBackTop(window.scrollY > 500);
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const style = document.createElement("style");
    style.textContent = `
      @keyframes fadeIn {
        from { opacity: 0; transform: translateY(10px); }
        to { opacity: 1; transform: translateY(0); }
      }

      * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
      }

      body {
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,
          Ubuntu, Cantarell, sans-serif;
        overflow-x: hidden;
        color: #1f2937;
        background: #ffffff;
      }

      ::-webkit-scrollbar {
        width: 10px;
      }

      ::-webkit-scrollbar-track {
        background: #f1f1f1;
      }

      ::-webkit-scrollbar-thumb {
        background: linear-gradient(135deg, #4f46e5, #818cf8);
        border-radius: 5px;
      }

      ::-webkit-scrollbar-thumb:hover {
        background: #4f46e5;
      }

      ::selection {
        background: #4f46e5;
        color: #ffffff;
      }
    `;

    document.head.appendChild(style);

    return () => {
      if (document.head.contains(style)) {
        document.head.removeChild(style);
      }
    };
  }, []);

  if (!shouldShowLayout) {
    return <>{children}</>;
  }

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        position: "relative",
        backgroundColor: "#ffffff",
      }}
    >
      <Navbar />

      <main
        key={location.pathname}
        style={{
          flex: 1,
          width: "100%",
          position: "relative",
          zIndex: 1,
          animation: "fadeIn 0.35s ease-in-out",
        }}
      >
        {children}
      </main>

      <Footer />

      <button
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        style={{
          position: "fixed",
          bottom: "30px",
          right: "30px",
          width: "45px",
          height: "45px",
          backgroundColor: "#4f46e5",
          color: "#ffffff",
          borderRadius: "50%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          cursor: "pointer",
          boxShadow: "0 4px 10px rgba(79, 70, 229, 0.3)",
          border: "none",
          transition: "all 0.3s ease",
          zIndex: 100,
          opacity: showBackTop ? 1 : 0,
          visibility: showBackTop ? "visible" : "hidden",
          transform: showBackTop ? "translateY(0)" : "translateY(10px)",
        }}
        aria-label="Back to top"
      >
        ↑
      </button>
    </div>
  );
}